'use strict';

export default class ViewGroupNodes {
  constructor() {
    this.name = 'view-group-nodes';
    var refereceLink = $('.view-display-id-user_local_group_link_hidden');
    var groupLinksElement = refereceLink.find('#group-links');

    if(groupLinksElement.length < 1) return;

    var link = $(`.${this.name}`).find(".view-header .action-links a");

    if(link.length < 1) return;
    
    var href = link.attr('href');
    href = href.replace("{{gid}}", groupLinksElement.data('id'));
    
    link.attr('href', href);
  }
}
